module.exports = __webpack_public_path__ + "fonts/iconfont.c235adad.woff";